import { lang } from "../../i18nLang";

export class InvalidParamException extends Error {
  protected _code: string;
  public readonly field: string;
  protected _customMessage?: string;

  constructor(field: string, message?: string) {
    super(`${message}: ${field}` || `Invalid field: ${field}`);

    this.name = "InvalidParamException";
    this._code = "invalidParam";
    this.field = field;
  }

  get customMessage() {
    return this._customMessage || this.messages.short;
  }

  get messages() {
    return {
      short: translateExceptions(this._code),
      long: translateExceptions(this._code, this.field),
    };
  }
}

export class RequiredParamException extends InvalidParamException {
  constructor(field: string, customMessage?: string) {
    super(field, "Required field");

    this.name = "RequiredParamException";
    this._code = "requiredParam";
    this._customMessage = customMessage;
  }
}

export class ImmutableParamException extends InvalidParamException {
  constructor(field: string, customMessage?: string) {
    super(field, "You can't update this field");

    this.name = "ImmutableParamException";
    this._code = "immutableParam";
    this._customMessage = customMessage;
  }
}

export class InvalidDateException extends InvalidParamException {
  constructor(field: string, customMessage?: string) {
    super(field, "Invalid date");

    this.name = "InvalidDateException";
    this._code = "invalidDate";
    this._customMessage = customMessage;
  }
}

export class InvalidEmailException extends InvalidParamException {
  constructor(field: string, customMessage?: string) {
    super(field, "Invalid email");

    this.name = "InvalidEmailException";
    this._code = "invalidEmail";
    this._customMessage = customMessage;
  }
}

export class InvalidCPFException extends InvalidParamException {
  constructor(field: string, customMessage?: string) {
    super(field, "Invalid CPF number");

    this.name = "InvalidCPFException";
    this._code = "invalidCPF";
    this._customMessage = customMessage;
  }
}

const translateExceptions = (code: string, field: string = "") => {
  if (field) field = `'${lang(`fields.${field}`).replace("fields.", "")}'`;
  return lang(`exceptions.${code}`, field).trim() + ".";
};
